module.exports = __webpack_public_path__ + "img/43_24.cd2b311c.png";